import {
    Avatar as MuiAvatar,
    createStyles,
    makeStyles,
    Tooltip,
} from "@material-ui/core";
import classnames from "classnames";
import * as React from "react";

import { baseColors, RelodeTheme } from "../";

const useStyles = makeStyles(
    (theme: RelodeTheme) =>
        createStyles({
            root: {},
            positionAbsolute: {
                position: "absolute",
                top: 49,
                left: -23,
                width: 44,
                height: 44,
            },
            matchScore: {
                fontSize: "1.2rem",
                fontWeight: "bold",
                margin: "auto",
                color: baseColors.black,
                backgroundColor: theme.palette.common.white,
                border: `solid 1px ${baseColors.black}`,
            },
            green: {
                border: `solid 2px ${baseColors.green}`,
            },
            yellow: {
                border: `solid 2px ${baseColors.warning_yellow}`,
            },
            red: {
                border: `solid 2px ${baseColors.danger_red}`,
            },
        }),
    { name: "MatchScoreAvatar" }
);

interface Props {
    score?: number;
    className?: string;
    positionAbsolute?: boolean;
}

export const MatchScoreAvatar = (props: Props) => {
    const { score, className: classNameProp, positionAbsolute = true } = props;
    const classes = useStyles({});
    const rootClassNames = classnames(
        {
            [classes.root]: true,
        },
        classNameProp
    );

    const avatarClassNames = classnames(
        {
            [classes.matchScore]: true,
            [classes.green]: !!score && score >= 85,
            [classes.yellow]: !!score && score >= 65 && score < 85,
            [classes.red]: !!score && score < 65,
            [classes.positionAbsolute]: positionAbsolute,
        },
        classNameProp
    );

    const scoreText = !!score ? `${Math.round(score)}` : "--";

    const scoreTitle =
        scoreText === "--"
            ? "Normally shows a score out of 100% indicating how good/bad this lead matches the job’s qualifications. Scores are calculated offline. Check back later for an update."
            : `A score of ${scoreText}% represents how good/bad this lead matches the job's qualifications`;

    return (
        <div className={rootClassNames}>
            <Tooltip placement="bottom-start" title={scoreTitle}>
                <MuiAvatar className={avatarClassNames}>{scoreText}</MuiAvatar>
            </Tooltip>
        </div>
    );
};
